import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync, faCamera } from "@fortawesome/free-solid-svg-icons";

const CameraControls = ({
  availableCameras,
  cameraReady,
  isModelLoaded,
  facePositionValid,
  onSwitchCamera,
  onCapture,
  onRefreshCamera,
}) => {
  const canShoot = cameraReady && isModelLoaded && facePositionValid;

  return (
    <div className="camera-controls">
      {availableCameras.length > 1 && (
        <button
          type="button"
          className="switch-camera-button"
          onClick={onSwitchCamera}
          disabled={!cameraReady}
          aria-label="החלפת מצלמה"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="23 4 23 10 17 10" />
            <polyline points="1 20 1 14 7 14" />
            <path d="M3.51 9a9 9 0 0114.36-3.36L23 10" />
            <path d="M20.49 15a9 9 0 01-14.36 3.36L1 14" />
          </svg>
        </button>
      )}

      {/* Camera refresh button - shown only when camera is not ready */}
      {(!cameraReady || !isModelLoaded) && (
        <div className="refresh-button-container">
          <span className="refresh-label">רענון מצלמה</span>
          <button
            type="button"
            className="refresh-camera-button"
            onClick={onRefreshCamera}
            aria-label="רענון מצלמה"
          >
            <FontAwesomeIcon icon={faSync} className="refresh-icon" />
          </button>
        </div>
      )}

      <button
        type="button"
        className={`capture-button ${canShoot ? "ready" : "hidden"}`}
        onClick={onCapture}
        disabled={!canShoot}
        aria-label="צלם תמונה"
      >
        <FontAwesomeIcon icon={faCamera} className="camera-icon" />
      </button>
    </div>
  );
};

export default CameraControls;
